import {
  createSlice,
  createAsyncThunk,
  createDraftSafeSelector,
} from '@reduxjs/toolkit';

import { api } from '../../api/api';
import { logout } from '../Login/loginSlice';

export const loadEngines = createAsyncThunk('engines/loadEngines', async () => {
  const response = await api.engines();
  return response;
});

// selectors
const selectSelf = (state) => state.engines;
export const selectEngines = createDraftSafeSelector(
  selectSelf,
  (engines) => engines.engines,
);

const engineSlice = createSlice({
  name: 'engines',
  initialState: {
    failedToLoad: false,
    loading: false,
    engines: [],
    allEngines: undefined,
  },
  reducers: {},
  extraReducers: {
    [loadEngines.pending]: (state) => {
      state.loading = true;
    },
    [loadEngines.fulfilled]: (state, action) => {
      state.loading = false;
      let enabledEngines = [];
      action.payload.forEach((engine) => {
        if (!engine.disabled && engine.models && engine.models.length > 0) {
          enabledEngines.push(engine);
        }
      });
      enabledEngines = enabledEngines.sort(sortAlphaNum);
      state.engines = enabledEngines;
      state.allEngines = action.payload;
    },
    [loadEngines.rejected]: (state, action) => {
      state.loading = false;
      state.failedToLoad = true;
      state.engines = [];
    },
    [logout]: (state) => {
      state.failedToLoad = false;
      state.engines = [];
      state.allEngines = undefined;
    },
  },
});

export const {} = engineSlice.actions;

export default engineSlice.reducer;

// alphanum sorter
function sortAlphaNum(c, d) {
  let a = ((c.models && c.models[0] && c.models[0].alias) || '').toLowerCase();
  let b = ((d.models && d.models[0] && d.models[0].alias) || '').toLowerCase();
  return a.localeCompare(b, 'en');
}
